import React from 'react';
import { Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useIdentity } from '@/framework';
import { useLocaleStore } from '@/i18n/index';
import { Layer } from '@/layers/layer';
import { BaseLayerViewType } from '@/version-types';

export const LockOperate: React.FC<{ layerId: string }> = React.memo(({ layerId }) => {
    const { $t } = useLocaleStore();
    const identity = useIdentity();

    return (
        <Tooltip placement="bottom" title={$t((v) => v.baseLayer.baseOperate.title)}>
            <div
                className="active-operate__lock"
                data-operate-type={BaseLayerViewType.LOCK}
                onClick={() => {
                    new Layer(identity).unlock(layerId);
                }}
                onMouseDown={(e) => {
                    e.stopPropagation();
                }}
            >
                <IconFont fontSize={14} name="LockBoldFill" />
            </div>
        </Tooltip>
    );
});
